import { MetadataStore } from "breeze-client";

/*function extendProject(metadataStore: MetadataStore) {
    var myEntityCtor = function () {
        this.newProp = "hi there";
    };

    // @ts-ignore: For some reason, it doens't recognize 'model', so this is just here to prevent the error from showing up in VS. Works just fine.
    var myEntityInitializer = (myEntity: model.project) => {
        myEntity.computedProp = () => {
            return myEntity.name ? myEntity.name.toUpperCase() : 'nay';
        }

        myEntity.hasChanges = () => {
            return myEntity.entityAspect.entityState.isAddedModifiedOrDeleted();
        };
    }

    metadataStore.registerEntityTypeCtor('Project', myEntityCtor, myEntityInitializer);
}*/

export function extendMetadata(metadataStore: MetadataStore) {
    //extendProject(metadataStore);
}

